<template>
  <div class="row row-margin-0 visible-sm visible-xs">
    <div class="col-xs-12">
      <a
        class="btn btn-v-lightgreen-white pull-right"
        :class="{ 'is-disabled': customerId == null }"
        href="/customers/customerId/merge/"
        v-tooltip="{
          content: $label('customer.merge_customers', 'Merge customers'),
          classes: 'custom-tooltip'
        }"
      >
        <i class="fa fa-fw fa-lg fa-compress"></i>
      </a>
      <a
        class="btn btn-v-lightgreen-white pull-right"
        :class="{ 'is-disabled': customerId == null }"
        href="/customers/customerId/journal/view/"
        v-tooltip="{
          content: $label('customer.note', 'Note'),
          classes: 'custom-tooltip'
        }"
      >
        <i class="fa fa-fw fa-lg fa-pencil"></i>
      </a>
      <a
        class="btn btn-v-lightgreen-white pull-right"
        :class="{ 'is-disabled': customerId == null }"
        href="/customers/customerId/message/sms/"
        v-tooltip="{
          content: $label('customer.sms', 'SMS'),
          classes: 'custom-tooltip'
        }"
      >
        <i class="fa fa-fw fa-lg fa-mobile"></i>
      </a>
      <a
        class="btn btn-v-lightgreen-white pull-right"
        :class="{ 'is-disabled': customerId == null }"
        href="/customers/customerId/message/email/"
        v-tooltip="{
          content: $label('customer.email', 'Email'),
          classes: 'custom-tooltip'
        }"
      >
        <i class="fa fa-fw fa-lg fa-envelope-o"></i>
      </a>
      <a
        class="btn btn-v-lightgreen-white pull-right"
        :class="{ 'is-disabled': customerId == null }"
        href="/venues/booking/customers/customerId"
        v-tooltip="{
          content: $label('customer.book_venue', 'Book venue'),
          classes: 'custom-tooltip'
        }"
      >
        <i class="fa fa-fw fa-lg fa-map-marker"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customerId: {
      default: null
    }
  }
};
</script>
